<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>
                    <span v-if="editMode">Urejanje projekta</span>
                    <span v-if="!editMode">Dodajanje projekta</span>
                </h1>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

<!--                {{project}}-->
<!--                <br/><br/>-->
<!--                {{users}}-->


                <b-form-group
                        id="name"
                        label="Vnesi ime projekta"
                        label-for="name">
                    <b-form-input id="name" v-model="project.name" trim></b-form-input>
                </b-form-group>


                <!--                <v-select-->
                <!--                        v-model="project.projectManager"-->
                <!--                        id="projectManager"-->
                <!--                        name="projectManager"-->
                <!--                        label="first_name"-->
                <!--                        :options='users'-->
                <!--                        :reduce="item => item.id"-->
                <!--                >-->
                <!--                    <template slot="option" slot-scope="item">-->
                <!--                        {{item.first_name}} {{item.last_name}}-->
                <!--                    </template>-->
                <!--                    <template slot="selected-option" slot-scope="item">-->
                <!--                        {{item.first_name}} {{item.last_name}}-->
                <!--                    </template>-->
                <!--                </v-select>-->

                <div class="form-group">

                    <label class="d-block">Ali je projekt trenutno aktiven?</label>

                    <b-form-checkbox
                            id="active"
                            v-model="project.active"
                            name="active"
                            value="true"
                            unchecked-value="false"
                    >
                        Projekt je aktiven
                    </b-form-checkbox>
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-md-12 mt-3">
                <div class="d-flex">
                    <button v-if="editMode" class="btn btn-danger mr-auto" @click="deleteProjectConfirmation()"><i class="fa fa-trash"></i>
                        Izbriši
                        projekt
                    </button>

                    <button v-if="!editMode" type="submit" @click="addProject()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Shrani podatke o projektu
                    </button>


                    <button v-if="editMode" type="submit" @click="updateProject()" class="btn btn-info ml-auto"><i
                            class="fa fa-save"></i> Posodobi podatke o projektu
                    </button>
                </div>

                <div>

                    <router-link :to="{ name: 'Projects'}" class="btn btn-link pt-4">
                        Prekliči
                    </router-link>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
  import firebase from 'firebase'
  import {db} from '../main'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'

  export default {
    name: 'EditProject',
    components: {
      vSelect
    },
    data () {
      return {
        project: {
          id: null,
          name: '',
          //projectManager: null
        },
        users: [],
        id: this.$route.params.id,
        editMode: false
      }
    },
    firestore () {
      if (this.id) {
        return {
          project: db.collection('projects').doc(this.id),
          // users: db.collection('users')
        }
      } else {
        return {
          // users: db.collection('users')
        }
      }
    },
    mounted () {

      if (this.id) {
        this.editMode = true
      } else {
        this.editMode = false
      }

    },
    methods: {

      updateProject (id) {
        const _this = this
        const currentProject = db.collection('projects').doc(this.id)

        return currentProject.update({
          name: _this.project.name,
          //projectManager: _this.project.projectManager,
          active: _this.project.active,
          updatedAt: new Date(),
          updatedBy: JSON.parse(sessionStorage.getItem('DP_user')).id,
          createdAt: _this.project.createdAt,
          createdBy: _this.project.createdBy
        })
          .then(function () {
            _this.$router.push('/projekti')
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error updating project: ', error)
          })

      },

      addProject () {
        const _this = this

        let ref = db.collection('projects').doc()
        ref.set({id: ref.id}) // set new document ID
          .then(() => {  // fetch the doc again and show its data
            ref.get().then(doc => {

              _this.id = doc.data().id
              _this.project.createdAt = new Date()
              _this.project.createdBy = JSON.parse(sessionStorage.getItem('DP_user')).id
              _this.updateProject()

            })
          })
      },
      deleteProjectConfirmation () {
        const _this = this

        this.$swal({
          title: 'Opozorilo',
          text: 'Ali ste prepričani, da želite izbrisati projekt ' + _this.project.name + '? Po potrditvi izbire ne bo več mogoče preklicati.',
          dangerMode: true,
          buttons: {
            cancel: {
              text: 'Prekliči',
              value: null,
              visible: true,
              className: '',
              closeModal: true,
            },
            confirm: {
              text: 'Izbriši',
              value: true,
              visible: true,
              className: '',
              closeModal: true
            }
          },
        })
          .then((value) => {

            switch (value) {

              case true:

                _this.deleteProject()

              case null:

                return

                break

              default:

            }
          })
      },
      deleteProject () {
        const _this = this

        db.collection('projects').doc(_this.id).delete()
          .then(function () {
            _this.$store.dispatch('retrieveEvents', true).then(() => {
              _this.$router.push('/projekti')
            })
          })
          .catch(function (error) {
            // The document probably doesn't exist.
            console.error('Error deleting project: ', error)
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/EditProject.vue